// This component was taken from
// https://gitlab.internal.equipmentshare.com/pim/pim-ui/-/blob/main/src/components/common/filters-v2/base/popover/index.tsx
import React, { useState } from "react";
import { Box, Popover, Skeleton, Stack } from "@mui/material";

import { defaultSlots, FilterSlotProps, FilterSlots } from "../slots";
import { SearchInput } from "../../../../../";

export type BaseFilterPopoverProps = {
  label: string;
  slots?: FilterSlots;
  slotProps?: FilterSlotProps;
  filterable?: boolean;
  onApplyChanges?: () => void;
  isLoading?: boolean;
  hasChanges?: boolean;
  onClose?: () => void;
  anchorEl?: HTMLElement | null;
  open?: boolean;
};

export const BaseFilterPopover = ({
  label,
  slots,
  onClose,
  slotProps,
  isLoading,
  hasChanges,
  filterable,
  onApplyChanges,
  anchorEl,
  open,
}: BaseFilterPopoverProps) => {
  const [searchValue, setSearchValue] = useState("");

  // TODO: The SearchInput component isn't fully controllable
  // i.e. passing a new value prop isn't reflected in the input
  const handleClose = () => {
    setSearchValue("");
    if (onClose) {
      onClose();
    }
  };

  const handleApplyChanges = () => {
    setSearchValue("");
    if (onApplyChanges) {
      onApplyChanges();
    }
  };

  const mergedSlots = { ...defaultSlots, ...slots };

  let content = mergedSlots.content({
    searchValue,
    ...slotProps?.content,
  });

  if (isLoading) {
    content = (
      <Stack>
        <Skeleton height={28} />
        <Skeleton height={28} />
      </Stack>
    );
  }

  return (
    <Popover
      open={!!open}
      anchorEl={anchorEl}
      onClose={handleClose}
      data-testid="filter-popover"
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <Box
        sx={{
          p: 1,
          gap: 1,
          minWidth: 200,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {mergedSlots.title({
          label: `Filter by ${label}`,
          ...slotProps?.title,
        })}
        {filterable && (
          <SearchInput
            autoApply
            value={searchValue}
            placeholder="Search"
            onApply={setSearchValue}
            onClear={() => setSearchValue("")}
            id={`search-${label.toLowerCase()}`}
            {...slotProps?.searchInput}
          />
        )}
        {content}
        {mergedSlots.actions({
          hasChanges,
          onClick: handleApplyChanges,
          ...slotProps?.actions,
        })}
      </Box>
    </Popover>
  );
};
